// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-note {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 20px;
  margin-bottom: 24px;
  border-radius: 12px;
  border: 1px solid #dbeafe;
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.om-table tbody tr.om-row--overdue {
  background-color: #fde8e8;
  color: #b91c1c;
}

.om-table tbody tr.om-row--duplicate {
  background-color: #fecaca;
  color: #991b1b;
  box-shadow: inset 4px 0 0 #dc2626;
}

.om-table tbody tr.om-row--duplicate:hover {
  background-color: #fca5a5;
}

.om-duplicate-badge {
  display: inline-block;
  margin-left: 0.5rem;
  padding: 0.125rem 0.4rem;
  border-radius: 999px;
  background: #b91c1c;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/ProductionGlassMonitoring.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;EAC7D,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":[".info-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  border-radius: 12px;\n  border: 1px solid #dbeafe;\n  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.om-table tbody tr.om-row--overdue {\n  background-color: #fde8e8;\n  color: #b91c1c;\n}\n\n.om-table tbody tr.om-row--duplicate {\n  background-color: #fecaca;\n  color: #991b1b;\n  box-shadow: inset 4px 0 0 #dc2626;\n}\n\n.om-table tbody tr.om-row--duplicate:hover {\n  background-color: #fca5a5;\n}\n\n.om-duplicate-badge {\n  display: inline-block;\n  margin-left: 0.5rem;\n  padding: 0.125rem 0.4rem;\n  border-radius: 999px;\n  background: #b91c1c;\n  color: #fff;\n  font-size: 0.7rem;\n  font-weight: 700;\n  line-height: 1.2;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
